let loadedScriptsCallbacks: { [id: string]: Promise<void> } = {};

export function loadScript(url: string, addCrossOriginAnonymous = true): Promise<void> {
    if (!loadedScriptsCallbacks[url]) {
        loadedScriptsCallbacks[url] = new Promise((resolve, reject) => {
            var element = window.document.createElement('script');
            element.src = url;
            element.type = 'text/javascript';
            if (addCrossOriginAnonymous) {
                element.crossOrigin = 'anonymous';
            }
            element.onload = () => {
                resolve();
            };
            element.onerror = () => {
                reject('OnError ' + url);
            };
            window.document.head.appendChild(element);
        });
    }

    return loadedScriptsCallbacks[url];
}

export function test_clearScriptsCallbacks() {
    loadedScriptsCallbacks = {};
}
